import React from "react";
import "./footer.css";
export default function index() {
  return (
    <>
      <section style={{ width: "100%" }} class="footer">
        <div class="footer-top">
          <div class="footer-links">
            <nav class="navbar navbar-expand-sm">
              <ul class="navbar-nav">
                <li class="nav-item">
                  <a
                    class="nav-link"
                    href="/terms-and-conditions"
                    target="_blank"
                  >
                    {" "}
                    Terms and Conditions{" "}
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    class="nav-link"
                    href="/responsible-gaming"
                    target="_blank"
                  >
                    {" "}
                    Responsible Gaming{" "}
                  </a>
                </li>
              </ul>
            </nav>
          </div>
          <div class="support-detail">
            <h2>24X7 Support</h2>
            <p />
          </div>
          <div class="social-icons-box" />
        </div>
      </section>
      <div style={{ width: "100%" }} className="footer-bottom">
        <div className="secure-logo">
          <div>
            <img src="https://wver.sprintstaticdata.com/v3/static/front/img/ssl.png" />
          </div>
          <div className="ml-2">
            <b>100% SAFE</b>
            <div>Protected connection and encrypted data.</div>
          </div>
        </div>
        <div className="d-inline-block">
          <button className="btn p-0">
            <img src="https://versionobj.ecoassetsservice.com/v22/static/front/img/18plus.png" />
          </button>
          <a href="https://www.gamcare.org.uk/" target="_blank">
            <img src="https://versionobj.ecoassetsservice.com/v22/static/front/img/gamecare.png" />
          </a>
          <a href="https://www.gamblingtherapy.org/" target="_blank">
            <img src="https://versionobj.ecoassetsservice.com/v22/static/front/img/gt.png" />
          </a>
        </div>
      </div>
      <div
        style={{
          width: "100%",
        }}
        class="footer-text"
      >
        <p />
        <p class="text-center">
          © Copyright 2025. All Rights Reserved. Powered by{" "}
          {window?.location?.hostname}.
        </p>
      </div>
    </>
  );
}
